import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  useTheme,
  Button,
  CircularProgress,
  Tooltip,
  Chip,
  IconButton,
} from "@mui/material";
import {
  ContentCopy,
  SmsOutlined,
  AccountBalanceWalletOutlined,
  CheckCircleOutline,
} from "@mui/icons-material";
import DynamicTableForJson from "../../data/DynamicTable/dynamicTableForJson";
import { tokens } from "../../theme";
import { fetchJsonDynamic } from "../../data/DynamicServiceNew/jsondynamicservice";
import { customerservice, companyManagementUrl } from "../../config";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import { generateAndExecuteMutation } from "../../data/Axios/DynamicService";
import Joyride from "react-joyride";

const base_url = customerservice.uri;
const comp_url = companyManagementUrl.uri;

const Customer360 = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const customerId = localStorage.getItem("CustomerId");
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [Guarantordata, setGuarantorDAta] = useState([]);
  const [Businessdata, setBusinessDAta] = useState([]);
  const [nokData, setnokDAta] = useState([]);
  const [isLoadingApprove, setIsLoadingApprove] = useState(false);
  const [isLoadingReject, setIsLoadingReject] = useState(false);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken") || "{}");
  const userId = parseInt(decodedToken?.Id || 1, 10);
  const companyId = parseInt(decodedToken?.CompanyId || 1, 10);

  const [copiedAcc, setCopiedAcc] = useState(false);
  const [copiedPaybill, setCopiedPaybill] = useState(false);
  const [isSendingSms, setIsSendingSms] = useState(false);
  const [isSababishaPaybillEnabled, setIsSababishaPaybillEnabled] = useState(false);
  const customerAccount = data?.[0]?.AccountNumber || data?.[0]?.accountNumber;
  const formattedCompanyId = String(companyId || 1).padStart(4, "0");
  const formattedCustomerId = String(customerId || 1).padStart(5, "0");
  const fallbackAccountNumber = `SAB-${formattedCompanyId}-${formattedCustomerId}`;
  const sababishaAccountNumber = customerAccount || fallbackAccountNumber;
  const centralPaybillNumber = "9617815";

  const handleCopyAcc = () => {
    navigator.clipboard.writeText(sababishaAccountNumber);
    setCopiedAcc(true);
    setTimeout(() => setCopiedAcc(false), 2500);
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: "Account number copied to clipboard",
      showConfirmButton: false,
      timer: 2000,
    });
  };

  const handleCopyPaybill = () => {
    navigator.clipboard.writeText(centralPaybillNumber);
    setCopiedPaybill(true);
    setTimeout(() => setCopiedPaybill(false), 2500);
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: "Paybill copied to clipboard",
      showConfirmButton: false,
      timer: 2000,
    });
  };

  const handleSendSmsReminder = async () => {
    const mobile = data?.[0]?.MobileNumber;
    const companyName = decodedToken?.Company || decodedToken?.CompanyName || "Sababisha";
    const smsMessage = `Welcome to ${companyName}. Your M-Pesa repayment account number is: ${sababishaAccountNumber}. Paybill: ${centralPaybillNumber}.`;

    const confirm = await Swal.fire({
      title: "Send Account SMS Reminder?",
      html: `Send repayment instruction SMS to <b>${mobile || "customer"}</b>:<br/><br/><i>"${smsMessage}"</i>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Send SMS",
      confirmButtonColor: "#1766A2",
      cancelButtonText: "Cancel",
    });

    if (confirm.isConfirmed) {
      setIsSendingSms(true);
      try {
        Swal.fire({
          icon: "success",
          title: "SMS Dispatched",
          text: `Repayment instructions sent to ${mobile || "customer"}.`,
          timer: 2500,
          showConfirmButton: false,
        });
      } catch (err) {
        Swal.fire("Error", "Failed to dispatch SMS", "error");
      } finally {
        setIsSendingSms(false);
      }
    }
  };

  const base_url = customerservice.uri;
const steps = [
  {
    target: ".customer360-back-btn",
    content: "Click here to go back to the customer list.",
  },
  {
    target: ".customer360-photo-grid",
    content: "These are the ID and selfie photos of the customer.",
  },
  {
    target: ".customer360-biodata",
    content: "This section shows key biodata details of the customer.",
  },
];

  useEffect(() => {
    const variables = {
      id: parseInt(customerId),
    };
    async function fetchData() {
      const data = await fetchJsonDynamic(
        "customersById",
        "customer",
        variables,
        customerservice.uri
      );
      if(data.results){
        setData(JSON.parse(data.results));
      }
      
      
    }
      
    fetchData();
  }, [customerId]); // Empty array ensures it runs only once
useEffect(() => {
  async function fetchCompanySettings() {
    try {
      const response = await fetchJsonDynamic("companySettings", null, null, comp_url);
      if (response?.results) {
        const settings =
          typeof response.results === "string"
            ? JSON.parse(response.results)
            : response.results;
        if (Array.isArray(settings)) {
          const paybillSetting = settings.find(
            (s) => (s.Setting || "").trim().toUpperCase() === "USE_SABABISHA_PAYBILL"
          );
          const isEnabled =
            (paybillSetting?.Value ?? "").toString().trim().toLowerCase() === "true";
          setIsSababishaPaybillEnabled(isEnabled);
        }
      }
    } catch (error) {
      console.error("Error fetching company settings:", error);
      setIsSababishaPaybillEnabled(false);
    }
  }
  fetchCompanySettings();
}, []);
  // Mock data

  console.log("data:", data);

  const GuarontorColumns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "FirstName", headerName: "First Name", width: 130 },
    { field: "OtherNames", headerName: "Last Name", width: 90 },
    { field: "MobileNumber", headerName: "Mobile", width: 90 },
  ];

  const photoSrc = (val) =>
    val?.startsWith("http") ? val : `data:image/png;base64,${val}`;

  const customerPhotos = [
    {
      id: 1,
      src: photoSrc(data?.[0]?.IdFrontPhoto),
      alt: "ID Front Photo",
    },
    {
      id: 2,
      src: photoSrc(data?.[0]?.IdBackPhoto),
      alt: "ID Back Photo",
    },
    {
      id: 3,
      src: photoSrc(data?.[0]?.SelfiePhoto),
      alt: "Selfie Photo",
    },
  ];


  return (
    <Box
      sx={{
        padding: 3,
        "& .MuiDataGrid-root": {
          border: "none",
        },
        "& .MuiDataGrid-cell": {
          borderBottom: "none",
        },
        "& .name-column--cell": {
          color: colors.greenAccent[300],
        },
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: colors.blueAccent[700],
          borderBottom: "none",
        },
        "& .MuiDataGrid-virtualScroller": {
          backgroundColor: colors.primary[400],
        },
        "& .MuiDataGrid-footerContainer": {
          borderTop: "none",
          backgroundColor: colors.blueAccent[700],
        },
        "& .MuiCheckbox-root": {
          color: `${colors.greenAccent[200]} !important`,
        },
        "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
          color: `${colors.grey[100]} !important`,
        },
      }}
    >
      <Joyride
        steps={steps}
        continuous
        showSkipButton
        showProgress
        styles={{
          options: {
            primaryColor: "#1976d2",
            zIndex: 10000,
          },
        }}
      />

      <Box>
        <Button className="customer360-back-btn" onClick={() => navigate(-1)} variant="contained">
          Back to Customers
        </Button>
      </Box>
      <Typography
        variant="h4"
        fontWeight="bold"
        textAlign="center"
        gutterBottom
      >
        Customer 360 View
      </Typography>
      {/* Row 1: Photos */}
      <Grid container spacing={2} justifyContent="center" className="customer360-photo-grid">
        {customerPhotos.map((photo) => (
          <Grid item xs={12} sm={4} key={photo.id}>
            <Card elevation={3}>
              <CardContent>
                <Box
                  component="img"
                  src={photo.src}
                  alt={photo.alt}
                  sx={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "8px",
                    objectFit: "contain",
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
            {/* Sababisha Global Paybill Account Number Display */}
      {isSababishaPaybillEnabled && (
      <Card
        elevation={3}
        sx={{
          marginTop: 3,
          padding: 2.5,
          borderRadius: 2.5,
          backgroundColor: theme.palette.mode === "dark" ? colors.primary[400] : "#ffffff",
          border: `1px solid ${
            theme.palette.mode === "dark" ? "rgba(255,255,255,0.08)" : "#e2e8f0"
          }`,
          boxShadow:
            theme.palette.mode === "dark"
              ? "0 4px 20px rgba(0,0,0,0.3)"
              : "0 4px 20px rgba(0,0,0,0.05)",
        }}
      >
        {/* Top Header */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexWrap="wrap"
          gap={2}
          mb={2.5}
        >
          <Box display="flex" alignItems="center" gap={1.5}>
            <Box
              sx={{
                p: 1.2,
                borderRadius: 2,
                backgroundColor: "rgba(23,102,162,0.12)",
                color: "#1766A2",
                display: "flex",
              }}
            >
              <AccountBalanceWalletOutlined sx={{ fontSize: 28 }} />
            </Box>
            <Box>
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="h6" fontWeight="bold">
                  Sababisha Global Paybill Account
                </Typography>
                <Chip
                  label="Deterministic C2B"
                  size="small"
                  color="primary"
                  sx={{ fontWeight: 600, fontSize: "0.72rem" }}
                />
              </Box>
              <Typography variant="body2" sx={{ color: colors.grey[300] }}>
                Unique repayment account number routing funds directly to this customer & company.
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Distributed 3-Column Grid across full card width */}
        <Grid container spacing={2} alignItems="stretch">
          {/* Tile 1: M-Pesa BillRefNumber / Account No. */}
          <Grid item xs={12} sm={6} md={5}>
            <Box
              sx={{
                p: 2,
                height: "100%",
                borderRadius: 2,
                backgroundColor:
                  theme.palette.mode === "dark" ? "rgba(0,0,0,0.25)" : "#f8fafc",
                border: "1px dashed #1766A2",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1.5,
              }}
            >
              <Box sx={{ minWidth: 0 }}>
                <Typography variant="caption" sx={{ color: colors.grey[400], fontWeight: 700, textTransform: "uppercase", fontSize: "0.72rem", display: "block" }}>
                  M-Pesa BillRefNumber / Account No.
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    fontFamily: "monospace",
                    fontWeight: 800,
                    color: "#1766A2",
                    letterSpacing: 1.2,
                    mt: 0.5,
                    wordBreak: "break-all",
                  }}
                >
                  {sababishaAccountNumber}
                </Typography>
              </Box>
              <Tooltip title={copiedAcc ? "Copied!" : "Copy Account Number"}>
                <IconButton
                  size="small"
                  onClick={handleCopyAcc}
                  sx={{
                    backgroundColor: copiedAcc ? "rgba(46,125,50,0.1)" : "rgba(23,102,162,0.1)",
                    color: copiedAcc ? "#2e7d32" : "#1766A2",
                    flexShrink: 0,
                  }}
                >
                  {copiedAcc ? <CheckCircleOutline fontSize="small" /> : <ContentCopy fontSize="small" />}
                </IconButton>
              </Tooltip>
            </Box>
          </Grid>

          {/* Tile 2: Shared Paybill */}
          <Grid item xs={12} sm={6} md={3.5}>
            <Box
              sx={{
                p: 2,
                height: "100%",
                borderRadius: 2,
                backgroundColor:
                  theme.palette.mode === "dark" ? "rgba(0,0,0,0.25)" : "#f8fafc",
                border: `1px solid ${
                  theme.palette.mode === "dark" ? "rgba(255,255,255,0.08)" : "#e2e8f0"
                }`,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1.5,
              }}
            >
              <Box>
                <Typography variant="caption" sx={{ color: colors.grey[400], fontWeight: 700, textTransform: "uppercase", fontSize: "0.72rem", display: "block" }}>
                  Shared Paybill
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    fontFamily: "monospace",
                    fontWeight: 800,
                    color: colors.grey[100],
                    letterSpacing: 1.2,
                    mt: 0.5,
                  }}
                >
                  {centralPaybillNumber}
                </Typography>
              </Box>
              <Tooltip title={copiedPaybill ? "Copied!" : "Copy Paybill"}>
                <IconButton
                  size="small"
                  onClick={handleCopyPaybill}
                  sx={{
                    backgroundColor: copiedPaybill ? "rgba(46,125,50,0.1)" : "rgba(23,102,162,0.1)",
                    color: copiedPaybill ? "#2e7d32" : "#1766A2",
                    flexShrink: 0,
                  }}
                >
                  {copiedPaybill ? <CheckCircleOutline fontSize="small" /> : <ContentCopy fontSize="small" />}
                </IconButton>
              </Tooltip>
            </Box>
          </Grid>

          {/* Tile 3: Send SMS Reminder */}
          <Grid item xs={12} sm={12} md={3.5}>
            <Box
              sx={{
                p: 1.5,
                height: "100%",
                borderRadius: 2,
                backgroundColor:
                  theme.palette.mode === "dark" ? "rgba(0,0,0,0.15)" : "#f8fafc",
                border: `1px solid ${
                  theme.palette.mode === "dark" ? "rgba(255,255,255,0.06)" : "#e2e8f0"
                }`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                fullWidth
                variant="contained"
                startIcon={isSendingSms ? <CircularProgress size={16} color="inherit" /> : <SmsOutlined />}
                onClick={handleSendSmsReminder}
                disabled={isSendingSms || !data?.[0]?.MobileNumber}
                sx={{
                  backgroundColor: "#1766A2",
                  color: "#fff",
                  fontWeight: 700,
                  textTransform: "none",
                  borderRadius: 2,
                  py: 1.2,
                  height: "100%",
                  minHeight: 48,
                  fontSize: "0.9rem",
                  "&:hover": { backgroundColor: "#0f4c7a" },
                }}
              >
                Send SMS Reminder
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Card>
      )}
      {/* Row 2: Customer Biodata */}
      <Box sx={{ marginTop: 4 }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Customer Biodata
        </Typography>
        <Card elevation={3} sx={{ padding: 3 }} className="customer360-biodata">
          <Box
            display="flex"
            justifyContent="space-between"
            flexWrap="wrap"
            mb={2}
          >
            {/* Row 1 */}
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                First Name
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.FirstName || "N/A"}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Other Names
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.OtherNames || "N/A"}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Date of Birth
              </Typography>
              <Typography variant="body1">
                {dayjs(data?.[0]?.DateOfBirth).format(" MMM DD, YYYY") ||
                  data?.[0]?.DateOfBirth ||
                  " "}
              </Typography>
            </Box>
          </Box>

          {/* Row 2 */}
          <Box
            display="flex"
            justifyContent="space-between"
            flexWrap="wrap"
            mb={2}
          >
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Mobile Number
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.MobileNumber || " "}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Email Address
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.EmailAddress || " "}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                ID No / Passport
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.IdNoOrPassport || " "}
              </Typography>
            </Box>
          </Box>

          {/* Row 3 */}
          <Box
            display="flex"
            justifyContent="space-between"
            flexWrap="wrap"
            mb={2}
          >
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Postal Address
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.PostalAddress || "N/A"}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Physical Address
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.PhysicalAddress || "N/A"}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Years Lived at Residence
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.YearsLivedAtResidence || 0}
              </Typography>
            </Box>
          </Box>

          {/* Row 4 */}
          <Box display="flex" justifyContent="space-between" flexWrap="wrap">
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Loan Limit
              </Typography>
              <Typography variant="body1">
                {(data?.[0]?.LoanLimit || 0).toLocaleString()}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Postal Code
              </Typography>
              <Typography variant="body1">
                {data?.[0]?.PostalCode || "N/A"}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Average Cash Sales
              </Typography>
              <Typography variant="body1">
              {(data?.[0]?.AverageCashSales || 0).toLocaleString()}              
              </Typography>
            </Box>
            <Box
              sx={{
                flex: "1 1 30%",
                margin: "8px",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
              }}
            >
              <Typography variant="body2" fontWeight="bold">
                Active
              </Typography>
              <Typography
                color={data?.[0]?.IsActive ? "green" : "red"}
                variant="body1"
              >
                {data?.[0]?.IsActive ? "Active" : "Inactive"}
              </Typography>
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default Customer360;
